export const joinTextMessage = (object: {
  [key: string]: string | null | undefined | ''
}) => {
  return Object.values(object)
    .filter((el) => el)
    .join('. ')
}
